var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper", class: { "modal-table": _vm.inModal } },
    [
      _vm.inModal
        ? _c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.modalTitle))])
        : _vm._e(),
      _vm._v(" "),
      _vm.auth
        ? _c("table", { staticClass: "branches-table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.list, function (e, i) {
                return _c("tr", { key: i }, [
                  _c("td", [_vm._v(_vm._s(e.name ? e.name : "—"))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(e.address ? e.address : "—"))]),
                ])
              }),
              0
            ),
          ])
        : _c("demo-message"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_c("b", [_vm._v("Наименование")])]),
        _vm._v(" "),
        _c("th", [_c("b", [_vm._v("Адрес")])]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }